/**
 *
 * Asynchronously loads the component for Financial Services
 *
 */

import loadable from '@loadable/component';

export default loadable(() => import('./index'));
